import { observer } from 'mobx-react'
import React, { useState } from 'react'
import cn from 'classnames'

import { HELP_ANY_TIME_IMG_URL } from '@flowwai-frontend/shared-web/ai-chat-support/ui'
import AIChatSupportRoute from '../../routes/AIChatSupportRoute/AIChatSupportRoute'

import * as Styles from './styles'
import { useAppTheme } from '@flowwai-frontend/bps-officer-web/style-guide'

const AIActionCenter = (): React.ReactElement => {
   const [showAIChatBox, setShowAIChatBox] = useState(false)

   const { theme } = useAppTheme()
   const themes = theme.aiChatSupport.aiActionCenter

   const onClickChatSupport = (): void => {
      setShowAIChatBox(true)
   }

   const renderFloatingButton = (): React.ReactElement => (
      <div className={Styles.floatingButtonStyles} onClick={onClickChatSupport}>
         <img
            src={HELP_ANY_TIME_IMG_URL}
            alt='AI action center'
            className={cn('rounded-full px-1', themes.iconBgColor)}
         />
      </div>
   )

   return (
      <>
         {renderFloatingButton()}
         {showAIChatBox ? (
            <AIChatSupportRoute
               onClose={() => {
                  setShowAIChatBox(false)
               }}
            />
         ) : null}
      </>
   )
}

export default observer(AIActionCenter)
